var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2508_20360",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2508_20360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.88302 29.3908C6.58635 29.3908 6.33774 29.29 6.13719 29.0883C5.93635 28.8867 5.83594 28.6367 5.83594 28.3383C5.83594 28.04 5.93635 27.7919 6.13719 27.5942C6.33774 27.3961 6.58635 27.2971 6.88302 27.2971H33.1222C33.4189 27.2971 33.6675 27.3979 33.868 27.5996C34.0689 27.8012 34.1693 28.0512 34.1693 28.3496C34.1693 28.6479 34.0689 28.8961 33.868 29.0942C33.6675 29.2919 33.4189 29.3908 33.1222 29.3908H6.88302ZM6.88302 21.0471C6.58635 21.0471 6.33774 20.9461 6.13719 20.7442C5.93635 20.5425 5.83594 20.2926 5.83594 19.9946C5.83594 19.6962 5.93635 19.4481 6.13719 19.25C6.33774 19.0519 6.58635 18.9529 6.88302 18.9529H33.1222C33.4189 18.9529 33.6675 19.0539 33.868 19.2558C34.0689 19.4575 34.1693 19.7074 34.1693 20.0054C34.1693 20.3037 34.0689 20.5519 33.868 20.75C33.6675 20.9481 33.4189 21.0471 33.1222 21.0471H6.88302ZM6.88302 12.7029C6.58635 12.7029 6.33774 12.6021 6.13719 12.4004C5.93635 12.1987 5.83594 11.9487 5.83594 11.6504C5.83594 11.3521 5.93635 11.1039 6.13719 10.9058C6.33774 10.7081 6.58635 10.6092 6.88302 10.6092H33.1222C33.4189 10.6092 33.6675 10.71 33.868 10.9117C34.0689 11.1133 34.1693 11.3633 34.1693 11.6617C34.1693 11.96 34.0689 12.2081 33.868 12.4058C33.6675 12.6039 33.4189 12.7029 33.1222 12.7029H6.88302Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.4dd9659974e8f01edca9e7801d62b72d.svg";
export { ForwardRef as ReactComponent };